import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getTrips } from "../../services/api/TripDetailsService";
import UpcomingTrips from "../../components/trips/upcoming-trips";
import { useDispatch } from "react-redux";
import { setLoading, setSnackbar } from "../../store/slices";
import useApiWrapper from "../../hooks/apiWrapper";
import { WrapperContainer } from "@corporate-trip-planner-fe/ui-styles";
import TrendingTripDestinations from "../../components/trips/trending-destinations";
import CreateTripCard from "../../components/trips/create-trip";
var ExplorePage = function () {
    var _a = useState(null), tripsData = _a[0], setTripsData = _a[1];
    var _b = useApiWrapper(setTripsData), inProgress = _b.inProgress, apiWrapper = _b.apiWrapper;
    var dispatch = useDispatch();
    var fetchTrips = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    //dispatch(setLoading(true));
                    return [4 /*yield*/, apiWrapper(getTrips)];
                case 1:
                    //dispatch(setLoading(true));
                    _a.sent();
                    //console.log(res);
                    //setTrips(res);
                    dispatch(setLoading(false));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    dispatch(setSnackbar({
                        message: "Some issue occured",
                        severity: "error",
                        open: true,
                    }));
                    dispatch(setLoading(false));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchTrips();
        //homeToken();
    }, []);
    return (_jsxs(WrapperContainer, { "$margin": "4rem 0 0 0", "$padding": "0", "$flexDirection": "column", children: [_jsx(UpcomingTrips, { trips: (tripsData === null || tripsData === void 0 ? void 0 : tripsData.filteredTrips) || [], inProgress: inProgress }), _jsx(TrendingTripDestinations, {}), _jsx(CreateTripCard, {})] }));
};
export default ExplorePage;
